module.exports = __webpack_public_path__ + "static/media/close.d01e5ead.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/close.svg
// module id = 321
// module chunks = 0